export default __webpack_public_path__ + "e1951519f6f0596f735635e962d5b82c.woff2";